import styled, { keyframes } from "styled-components";
import TextView from "../TextView";
import { device } from "../../utils/device";

// Keyframes for opening and closing animation
const slideIn = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

// Container with dynamic animation based on the `isOpen` prop
export const HotbarContainer = styled.div`
  width: 25vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;

  display: flex;
  flex-direction: column;

  /* Animate in/out */
  animation: ${(props) => (!props.isMobilePortrait && (props.isOpen ? slideIn : slideOut))} 0.3s ease-in-out
    forwards;

  /* Hide scroll bar for the entire container—scrolling will happen in Content only */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (${device.mobilePortrait}) {
    width: 100vw;
    border-radius: 0px;
  }
`;

export const Header = styled.div`
  position: sticky;
  top: 0; /* sticks to the top of the container */
  z-index: 2; /* ensure it stays above content when scrolling */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
  /* Add box-shadow or border if you want a clear separation from content */
`;
export const TabsWrapper = styled.div`
  position: sticky;
  top: ${({ isBuilderHotbar }) => !isBuilderHotbar && "72px"};
  z-index: 2;
  background-color: #ffffff;
`;
export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px;
`;

export const TitleWithIcon = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Title = styled(TextView)`
  font-size: 20px;
  font-weight: bold;
  margin-left: 5px;
`;
